module.exports = __webpack_public_path__ + "static/media/lichuangjingbao.3246746.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/lichuangjingbao.mp3
// module id = haZn
// module chunks = 16